import axios from 'axios';

export function fetchChatMessages(pageContent, offset, start, end) {
  return (
    axios.get(`https://api-chat.hirist.com/v1/admin/history?pageContent=${pageContent}&offset=${offset}&startTimestamp=${start.toString()}&endTimestamp=${end.toString()}`)
      .then(res => res.data)
      .catch(err => err)
  )
}
